import { BaseTable, Loading, TableHeader } from "components";
import { Fragment } from "react";
import { useList } from "./utils";
import moment from "moment";
import { convertNumber } from "utils";

export function TabCount(props: {
    dateFrom: string;
    dateEnd: string;
}): JSX.Element {

    const productId = localStorage.getItem("prdId")

    const { data, isLoading } = useList({
        start_date: props.dateFrom,
        end_date: props.dateEnd,
        product_id: Number(productId)
    });

    const getStatusLabel = (status?: number): string => {
        const statusMap: Record<number, string> = {
            1: "Count",
            2: "Adjustment",
            3: "Complete",
        };
        return status ? statusMap[status] || "-" : "-";
    };

    const totalSoh = data.reduce((prev, curr) => prev + Number(curr?.soh ?? 0), 0);
    const totalCount = data.reduce((prev, curr) => prev + Number(curr?.real_count ?? 0), 0);
    const totalDifference = data.reduce((prev, curr) => prev + Number(curr?.different ?? 0), 0);

    return (
        <Fragment>
            <section className="mt-2">
                <div className="overflow-x-auto">
                    <BaseTable className="border-transparent">
                        <TableHeader>
                            <tr className="uppercase">
                                <th>NO</th>
                                <th>COUNT ID#</th>
                                <th>DATE</th>
                                <th>LOCATION</th>
                                <th>TRADER</th>
                                <th>STATUS</th>
                                <th>MEMO</th>
                                <th>SOH</th>
                                <th>COUNT</th>
                                <th>DIFFERENCE</th>
                            </tr>
                        </TableHeader>
                        <tbody>
                            {!data.length || isLoading
                                ? <tr><td colSpan={10} className="text-center"><Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} /></td></tr>
                                : data.map((val, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{val?.trx_code ?? ""}</td>
                                        <td>{moment(val?.transaction_date).format("DD/MM/YYYY")}</td>
                                        <td>{val.location_name}</td>
                                        <td>{val.employee_name}</td>
                                        <td>{getStatusLabel(val?.count_status)}</td>
                                        <td>{val.memo}</td>
                                        <td className="text-right">{val.soh ? convertNumber(Number(val.soh)).intoNormalAmount : ""}</td>
                                        <td className="text-right">{val.real_count ? `${convertNumber(Number(val.real_count))?.intoNormalAmount}` : ""}</td>
                                        <td className="text-right">{val.different ? convertNumber(Number(val.different))?.intoCurrency : ""}</td>
                                    </tr>
                                ))
                            }

                            <tr className="font-bold">
                                <td colSpan={7} className="text-right">SUMMARY</td>
                                <td className="text-right">{totalSoh ? `${convertNumber(totalSoh)?.intoNormalAmount}` : "0"}</td>
                                <td className="text-right">{totalCount ? `${convertNumber(totalCount)?.intoNormalAmount}` : "0"}</td>
                                <td className="text-right">{totalDifference ? convertNumber(totalDifference)?.intoCurrency : "0"}</td>
                            </tr>
                        </tbody>
                        <tfoot >

                        </tfoot>
                    </BaseTable>
                </div>
            </section>
        </Fragment>
    )
}